import OrderCardCore from "./OrderCardCore";
import styles from "./OrderCardCore.module.scss";
import PlusCircle from "@assets/icons/PlusCircle.svg";

export const EmptyCard = ({ onClick }: { onClick: () => void }) => (
  <OrderCardCore
    isAlwaysOpen
    viewDetails={false}
    wrapperStyle={styles.emptyCard}
  >
    <div className={styles.content}>
      <img src={PlusCircle} alt="plusCirlce" />
      <button onClick={onClick}>Add new SO</button>
    </div>
  </OrderCardCore>
);
